import React from 'react';
import { motion } from 'framer-motion';
export function Summary() {
  return <section id="about" className="py-24 bg-bg-alt" data-id="element-103">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-105">
          {/* Heading with left gold bar */}
          <div className="md:col-span-3" data-id="element-106">
            <div className="flex items-start gap-4" data-id="element-107">
              <div className="w-[3px] h-10 bg-gold shrink-0 mt-1" data-id="element-108"></div>
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-primary leading-tight" data-id="element-109">
                About Me
              </h3>
            </div>
          </div>

          {/* Content */}
          <div className="md:col-span-9" data-id="element-110">
            <p className="font-sans text-base md:text-lg text-charcoal leading-relaxed" data-id="element-111">
              Senior finance executive with{' '}
              <span className="font-semibold text-primary" data-id="element-112">
                25+ years of experience
              </span>{' '}
              across global financial institutions, specializing in enterprise
              risk management, treasury optimization, derivatives, and capital
              markets.
            </p>
            <p className="font-sans text-base md:text-lg text-charcoal leading-relaxed mt-6" data-id="element-113">
              Proven track record of building robust risk frameworks, leading
              global teams, and driving strategic alignment between risk
              governance and financial performance across tier-1 institutions.
            </p>
            <p className="font-sans text-base md:text-lg text-charcoal leading-relaxed mt-6" data-id="element-114">
              Adept at navigating{' '}
              <span className="font-semibold text-primary" data-id="element-115">
                complex regulatory environments
              </span>{' '}
              and negotiating high-stakes ISDA/CSA agreements to optimize
              capital allocation — consistently delivering measurable results
              across high-accountability institutions.
            </p>

            {/* Divider */}
            <div className="w-24 h-[2px] bg-gold/40 mt-10 mb-8" data-id="element-116"></div>

            {/* Professional Resources */}
            <h4 className="font-sans text-sm font-bold text-primary mb-4" data-id="element-117">
              Professional Resources
            </h4>
            <div className="flex flex-wrap gap-3" data-id="element-118">
              <a href="#experience" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-primary bg-white border border-slate-200 px-5 py-2.5 rounded hover:border-primary/30 hover:shadow-sm transition-all duration-200" data-id="element-119">
                <span className="text-gold" data-id="element-120">📄</span>
                Executive Resume
              </a>
              <a href="#skills" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-primary bg-white border border-slate-200 px-5 py-2.5 rounded hover:border-primary/30 hover:shadow-sm transition-all duration-200" data-id="element-121">
                <span className="text-gold" data-id="element-122">📊</span>
                Core Competencies
              </a>
              <a href="#contact" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-primary bg-white border border-slate-200 px-5 py-2.5 rounded hover:border-primary/30 hover:shadow-sm transition-all duration-200" data-id="element-123">
                <span className="text-gold" data-id="element-124">✉️</span>
                Contact
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}